// 1st form
var quoteTypeId = null;
var productTypeId = null;
var originTypeId = null;
var portTypeId = null;
var packagingTypeId = null;
var quantityTypeId = null;
// 2nd form
var portLoadingId = null;
var modeOfTransportId = null;
var containerTypeId = null;
// 3rd form
var fullName = null;
var email = null;

var step = 1;
var reachedStep = 1;
var nameValidationError = false;
var emailValidationError = false;

$(document).ready(function () {
    let pageUrl = window.location.href;
    if (pageUrl.includes('get-quote')) {
        body.style.overflow = 'hidden';
    }
    // google maps places autocomplete
    var autocomplete;
    var id = 'location';
    setTimeout(() => {
        (async function initMap() {
            try {
                autocomplete = await new google.maps.places.Autocomplete(document.getElementById(id), {
                    types: ['geocode'],
                });
            } catch (error) {
                console.log('error loading places', error);
            }
        })();
    }, 1000);

    $('.dropdown-icon').on('click', function (event) {
        event.stopPropagation();
        event.stopImmediatePropagation();
        $('.select-options').hide();

        $(this).parent().next().toggle();
        $(this).parent().toggleClass('select-focus');
        // console.log($(this).parent().next().attr('class').split(/\s+/));

        let selectOptionsDiv = $(this).parent().next();
        let bottomOfDiv = selectOptionsDiv.offset().top + selectOptionsDiv.height();
        let topOfBottomBar = $('.actions').offset().top;

        if (bottomOfDiv > topOfBottomBar) {
            let amountToMoveUp = bottomOfDiv - topOfBottomBar + 30;
            selectOptionsDiv.css({marginTop: '-=' + amountToMoveUp + 'px'});
        }
    });

    // Close select clicking outside
    $(document).on('click', function (event) {
        if (!$(event.target).closest('.select-options').length) {
            $('.select-options').hide();
            $('.select-focus').removeClass('select-focus');
        }
    });

    $('#location2').on('click', function () {
        var id2 = 'location2';

        (async function initMap() {
            try {
                autocomplete = await new google.maps.places.Autocomplete(document.getElementById(id2), {
                    types: ['geocode'],
                });
            } catch (error) {
                console.log('error loading places', error);
            }
        })();
    });

    //Change quote type select
    $('.option').on('click', function () {
        $('.select-options').hide();

        // Form 1
        if ($(this).attr('data-quote-type-id') !== undefined) {
            quoteTypeId = $(this).attr('data-quote-type-id');

            // show additional fields for consolidation
            if (quoteTypeId == 4) {
                $('.consolidation').css('display', 'flex');
                $('.container-type').css('display', 'none');
                $('.country-of-origin-extras').css('display', 'grid');
                $('.port-of-discharge').css('display', 'none');
            } else {
                $('.consolidation').css('display', 'none');
                $('.container-type').css('display', 'grid');
                $('.country-of-origin-extras').css('display', 'none');

                //remove all country oprigin clones
                let elements = document.getElementsByClassName('country-origin-clone');
                while (elements.length > 0) {
                    elements[0].parentNode.removeChild(elements[0]);
                }

                //From origin to port of loading
                if (quoteTypeId == 1) {
                    $('.port-of-discharge').css('display', 'none');
                } else {
                    $('.port-of-discharge').css('display', 'block');
                }
            }

            // show additional fields for origin to final destination form
            if (quoteTypeId == 3) {
                $('.origin-to-final-destination').css('display', 'grid');
            } else {
                $('.origin-to-final-destination').css('display', 'none');
            }
        }

        // console.log($(this).text());
        $(this).parent().prev().find('input').val($(this).text());
        $(this).parent().prev().find('input').next().val($(this).attr('data-id'));

        //step
        if (step == 2) {
            shippingFormValidation();
        }
        if (step == 3) {
            contactFormValidation();
        }
    });

    $('#search-discharge').on('keyup', function (evt) {
        let search = evt.target.value;
        let counter = 0;
        // looping through api results
        $('.search-option').each(function () {
            // console.log($(this).attr('data-search-text'));
            if ($(this).attr('data-search-text').toLowerCase().includes(search.toLowerCase()) || search == '') {
                if (counter < 6) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
                counter++;
            } else {
                $(this).hide();
            }
        });
    });

    // add country text on consolidation choice.
    $('.add-country-text, .add-country-icon').on('click', function (event) {
        console.log('clicked add country');
        let clone = $('#reusable-wrapper').clone(true);
        clone.find('input').val('');
        clone.addClass('country-origin-clone');
        clone.appendTo('#add-country');
    });

    // Closing modal
    $('.close-quote-modal').on('click', function (event) {
        $('.get-quote-modal').fadeOut();
        body.style.overflow = 'auto';
        // reset the form steps
        //resetStep();
        resetForm();
        $('.thank-you-container').hide();
    });
    // Closing contact us modal
    $('.close-contact-us-modal').on('click', function (event) {
        $('.thank-you-container-contact-us').css('display', 'none');
        body.style.overflow = 'auto';
    });

    //Sets the step to 1
    const resetStep = () => {
        step = 1;
        $('.quote-details').show();
        $('.shipping-details').hide();
        $('.contact-details').hide();
        $('.go-back').hide();
        $('.go-next').show();
        $('.submit-btn').hide();
    };

    //resets all the form values
    const resetForm = () => {
        step = 1;
        $('.quote-details').show();
        $('.shipping-details').hide();
        $('.contact-details').hide();
        $('.go-back').hide();
        $('.go-next').show();
        $('.submit-btn').hide();

        console.log('resetting form');
        quoteTypeId = null;
        productTypeId = null;
        originTypeId = null;
        portTypeId = null;
        packagingTypeId = null;
        quantityTypeId = null;
        // 2nd form
        portLoadingId = null;
        modeOfTransportId = null;
        containerTypeId = null;
        // 3rd form
        fullName = null;
        email = null;
        reachedStep = 1;

        document.getElementById('product-form').reset();
        document.getElementById('shipping-form').reset();
        document.getElementById('contact-form').reset();

        const nextURL = '/';
        const nextTitle = 'Asili';
        const nextState = {};
        // This will create a new entry in the browser's history, without reloading
        window.history.pushState(nextState, nextTitle, nextURL);
        // This will replace the current entry in the browser's history, without reloading
        window.history.replaceState(nextState, nextTitle, nextURL);
    };

    // 1st form validation
    $('#product-form').on('DOMSubtreeModified input change', function () {
        var productForm = $('#product-form').serializeArray();
        // console.log('PRODUCT FORM', productForm);
        enableBtn = true;
        productForm.forEach((item) => {
            if (item.value === '') {
                enableBtn = false;
            }
        });
        if (enableBtn) {
            $('.go-next').prop('disabled', false);
            // update steps
        } else {
            $('.go-next').prop('disabled', true);
        }
    });

    // 2nd form validation
    $('.asili-shipping-form').on('DOMSubtreeModified input change', function () {
        shippingFormValidation();
    });

    function shippingFormValidation() {
        let shippingForm = $('#shipping-form').serializeArray();
        console.log('SHIPPING FORM', shippingForm);
        console.log('Quote type id: ', quoteTypeId);
        enableBtn = true;
        // check to see what form we are working with
        switch (quoteTypeId) {
            case '1':
                //ORIGIN TO PORT OF LOADING
                shippingForm.forEach((item) => {
                    if ((item.name === 'port_of_loading' || item.name === 'mode_of_transport' || item.name === 'container_type') && item.value === '') {
                        enableBtn = false;
                    }
                });
                break;
            case '2':
                //ORIGIN TO PORT OF DISCHARGE
                shippingForm.forEach((item) => {
                    if ((item.name === 'port_of_loading' || item.name === 'port_of_discharge' || item.name === 'mode_of_transport' || item.name === 'container_type') && item.value === '') {
                        enableBtn = false;
                    }
                });
                break;
            case '3':
                //ORIGIN TO FINAL DESTINATION
                shippingForm.forEach((item) => {
                    if (item.value === '' && item.name != 'arrival_date') {
                        enableBtn = false;
                    }
                });
                break;
            case '4':
                //CONSOLIDATION
                shippingForm.forEach((item) => {
                    if ((item.name === 'port_of_loading' || item.name === 'mode_of_transport') && item.value === '') {
                        enableBtn = false;
                    }
                });
                break;
        }

        if (enableBtn) {
            $('.go-next').prop('disabled', false);
        } else {
            $('.go-next').prop('disabled', true);
        }
    }
    // 3rd form validation
    $('#contact-form').on('DOMSubtreeModified input change', function () {
        contactFormValidation();
    });

    function contactFormValidation() {
        var contactForm = $('#contact-form').serializeArray();
        console.log('CONTACT FORM', contactForm);
        enableBtn = true;
        nameValidationError = false;
        emailValidationError = false;

        contactForm.forEach((item) => {
            if (item.value === '') {
                enableBtn = false;
            }
            if (item.name == 'name') {
                if (item.value != '' && (item.value.length < 3 || item.value.length > 25)) {
                    nameValidationError = true;
                    enableBtn = false;
                }
            }
            if (item.name == 'email_address') {
                console.log(validateEmail(item.value));
                if (item.value != '' && !validateEmail(item.value)) {
                    emailValidationError = true;
                    enableBtn = false;
                }
            }
        });

        if (nameValidationError) {
            $('.name-error').css('display', 'flex');
        } else {
            $('.name-error').css('display', 'none');
        }
        if (emailValidationError) {
            $('.email-error').css('display', 'flex');
        } else {
            $('.email-error').css('display', 'none');
        }
        if (enableBtn) {
            $('.submit-btn').prop('disabled', false);
        }
    }

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };

    // Go next
    $('.go-next').on('click', function (event) {
        goNext();
    });

    function goNext() {
        $('.quote-details').hide();

        step++;
        if (step > reachedStep) {
            reachedStep = step;
        }
        if (step == 2) {
            //$('.shipping-details').show();

            $('.shipping-details')
                .css({
                    'opacity': '0',
                    'display': 'block',
                })
                .show()
                .animate({opacity: 1});

            $('.go-back').show();
            $('.have-account').css('display', 'none');
            $('.have-account-filler').css('display', 'block');
            // update steps
            $('.step-1').addClass('completed');
            $('.step-2').addClass('active');
            $('.go-next').prop('disabled', true);
            $('.submit-btn').prop('disabled', true);
            //Run shipping form validation
            shippingFormValidation();
        } else if (step == 3) {
            //$('.contact-details').show();

            $('.contact-details')
                .css({
                    'opacity': '0',
                    'display': 'block',
                })
                .show()
                .animate({opacity: 1});

            $('.submit-btn').show();
            $('.go-next').hide();
            $('.have-account').css('display', 'none');
            $('.have-account-filler').css('display', 'block');
            // update steps
            $('.step-2').addClass('completed');
            $('.step-3').addClass('active');
            $('.go-next').prop('disabled', true);
        }
    }

    //Go to step 1
    $('.step-1').on('click', function (event) {
        if (step > 1) {
            step = 1;

            $('.go-next').prop('disabled', false);
            $('.quote-details').show();
            $('.shipping-details').hide();
            $('.contact-details').hide();
            $('.go-back').hide();
            $('.have-account').css('display', 'block');
            $('.have-account-filler').css('display', 'none');
        }
    });

    //Go to step 2
    $('.step-2').on('click', function (event) {
        if (reachedStep > 1) {
            $('.quote-details').hide();
            //check if step 1 valid
            step = 2;

            $('.go-next').prop('disabled', false);
            $('.shipping-details').show();
            $('.go-back').show();
            $('.go-next').show();
            $('.submit-btn').hide();
            $('.have-account-filler').css('display', 'block');
        }
    });

    //Go to step 3
    $('.step-3').on('click', function (event) {
        if (reachedStep > 2) {
            //check if step 1 valid
            $('.shipping-details').hide();
            $('.quote-details').hide();
            step = 3;

            $('.contact-details')
                .css({
                    'opacity': '0',
                    'display': 'block',
                })
                .show()
                .animate({opacity: 1});

            $('.submit-btn').show();
            $('.go-next').hide();
            $('.have-account').css('display', 'none');
            $('.have-account-filler').css('display', 'block');
            // update steps
            $('.step-2').addClass('completed');
            $('.step-3').addClass('active');
            $('.go-next').prop('disabled', true);
        }
    });

    // Go back
    $('.go-back').on('click', function (event) {
        $('.quote-details').hide();

        step--;

        if (step == 1) {
            $('.go-next').prop('disabled', false);
            $('.quote-details').show();
            $('.shipping-details').hide();
            $('.contact-details').hide();
            $('.go-back').hide();
            $('.have-account').css('display', 'block');
            $('.have-account-filler').css('display', 'none');
            //Active nav step
            $('.step-1').removeClass('completed');
            $('.step-2').removeClass('completed');
            $('.step-3').removeClass('completed');
            $('.step-1').removeClass('active');
            $('.step-2').removeClass('active');
            $('.step-3').removeClass('active');
            $('.step-1').addClass('active');
        } else if (step == 2) {
            $('.go-next').prop('disabled', false);
            $('.shipping-details').show();
            $('.go-back').show();
            $('.go-next').show();
            $('.submit-btn').hide();
            $('.have-account-filler').css('display', 'block');

            //Active nav step
            $('.step-1').removeClass('completed');
            $('.step-2').removeClass('completed');
            $('.step-3').removeClass('completed');
            $('.step-1').removeClass('active');
            $('.step-2').removeClass('active');
            $('.step-3').removeClass('active');
            $('.step-1').addClass('completed');
            $('.step-2').addClass('active');
        }
    });

    //Remove country of irigion
    $('.remove-country-origin').on('click', function (event) {
        console.log($(this).parent().parent().remove());
    });

    // Submit

    $('.submit-btn').on('click', function (event) {
        var productForm = $('#product-form').serializeArray();
        var shippingForm = $('#shipping-form').serializeArray();
        var contactForm = $('#contact-form').serializeArray();

        var newQuote = productForm.concat(shippingForm, contactForm);

        console.log('HERE IS YOUR NEW QUOTE: ', newQuote);

        // Temporary code here delete when checks to see if all fields are present
        $('.thank-you-container').show();

        // logic to submit form goes here
        var route = 'submit-quote';

        $.ajax({
            type: 'GET',
            url: route,
            data: newQuote,
            success: function (response) {
                if (response?.status === 'error') {
                    // alert(response.message);
                } else {
                    // successModal.style.display = 'block';
                    // yachtEnquireModal.style.display = 'none';
                    // yachtDetailsModal.style.display = 'none';
                }
            },
        });

        $('.get-quote-container').hide();

        resetStep();

        // after api submission
        $('#product-form').trigger('reset');
        $('#shipping-form').trigger('reset');
        $('#contact-form').trigger('reset');
        // reset steps
        $('.step-1').addClass('active');
        $('.step-2').removeClass('completed');
        $('.step-3').removeClass('completed');
    });

    //hidden fields not egtting reset on form reset

    $('#product-form').on('reset', function () {
        $("input[type='hidden']", $(this)).val('');
    });
    $('#shipping-form').on('reset', function () {
        $("input[type='hidden']", $(this)).val('');
    });
    $('#contact-form').on('reset', function () {
        $("input[type='hidden']", $(this)).val('');
    });

    //Date formatting
    $('#expectedDateInput').keyup(function () {
        var key = event.keyCode || event.charCode;

        if (key == 8 || key == 46) {
            return false;
        }
        console.log(this.value);
        let value = this.value.replace(/\D/g, ''); //only numbers
        value = value.substring(0, 6); //Limit to 6 00/00/00
        arrOf = value.match(/.{1,2}/g);
        if (value.length > 3) {
            if (arrOf[2]) {
                value = arrOf[0] + '/' + arrOf[1] + '/' + arrOf[2];
            } else {
                value = arrOf[0] + '/' + arrOf[1] + '/';
            }
        } else if (value.length > 1) {
            if (arrOf[1]) {
                value = arrOf[0] + '/' + arrOf[1];
            } else {
                value = arrOf[0] + '/';
            }
        }

        $(this).val(value);
    });

    $('.date-quote-icon').on('click', function (event) {
        console.log('asd');
        event.preventDefault();
        $('#expectedDateInput').focus();
    });

    $('.quote-date-pick').datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: 'dd/mm/y',
        onSelect: (val) => {
            console.log(val);
            // $('expectedDateInput').val(val);
        },
    });
});
